import * as React from "react";
import { useDispatch } from "react-redux";

import { getEnv } from "@/env";
import { EVENT_TYPES, triggerEvent } from "@/events";
import { openCustomerSelectModal as openCustomerSelectModalAction } from "@/react/features/customer/customerSlice";

const useCustomerSelectModal = () => {
  const dispatch = useDispatch();

  return React.useCallback(() => {
    if (getEnv("VUE_APP_ENABLE_REACT_CUSTOMER_MODAL", true)) {
      dispatch(openCustomerSelectModalAction());
    } else {
      triggerEvent(EVENT_TYPES.OPEN_CUSTOMER_SELECT);
    }
  }, [dispatch]);
};

export default useCustomerSelectModal;
